import { render, staticRenderFns } from "./MarketplaceChallanView.vue?vue&type=template&id=e622fc1e&scoped=true&"
import script from "./MarketplaceChallanView.vue?vue&type=script&lang=js&"
export * from "./MarketplaceChallanView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e622fc1e",
  null
  
)

export default component.exports